module.exports = __webpack_public_path__ + "static/img/sh_banner.dd1a5e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sh_banner.png
// module id = gJWB
// module chunks = 1